module.exports = __webpack_public_path__ + "static/media/star-of-david.b2bec2f2.svg";